import { FormEvent } from 'react'
import { IEmployeeSummary } from 'types/Employee'

export const groupBy = <T, K extends keyof any>(list: T[], getKey: (item: T) => K) =>
  list.reduce((previous, currentItem) => {
    const group = getKey(currentItem)
    if (!previous[group]) previous[group] = []
    previous[group].push(currentItem)
    return previous
  }, {} as Record<K, T[]>)

export const uniqByProp = (prop: string) => (arr: any[]) =>
  Object.values(arr.reduce((acc, item) => (item && item[prop] ? { ...acc, [item[prop]]: item } : acc), {}))

export const getCurrentEmployee = (): IEmployeeSummary | null => {
  const currentEmployee = localStorage.getItem('employee')
  if (!(currentEmployee === null || currentEmployee === undefined)) {
    return JSON.parse(currentEmployee) as IEmployeeSummary
  }
  return null
}

export const saveAsExcelFile = (buffer: BlobPart, fileName: string) => {
  import('file-saver').then((FileSaver) => {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    let EXCEL_EXTENSION = '.xlsx'
    const data = new Blob([buffer], {
      type: EXCEL_TYPE,
    })
    FileSaver.saveAs(data, fileName + ' ' + new Date().getTime() + EXCEL_EXTENSION)
  })
}

export const roundPercentages = (values: number[]) => {
  if (values.length === 1) {
    return values.map((v) => Math.round(v))
  } else {
    const flooredValues = values.map((e) => Math.floor(e))
    const remainders = values.map((e) => e - Math.floor(e))
    const sumFlooredVal = !values.length ? 0 : flooredValues.reduce((a, b) => a + b)
    const totalRemainder = 100 - sumFlooredVal

    // Deep copy because order of remainders is important
    ;[...remainders]
      // Sort from highest to lowest remainder
      .sort((a, b) => b - a)
      // Get the n largest remainder values, where n = totalRemainder
      .slice(0, totalRemainder)
      // Add 1 to the floored percentages with the highest remainder (divide the total remainder)
      .forEach((e) => {
        if (e !== 0) return (flooredValues[remainders.indexOf(e)] += 1)
      })
    return flooredValues
  }
}

export const licenceRegex =
  /^(0[1-9]|[1-7][0-9]|8[01])(([a-zA-Z])(\d{4,5})|([a-zA-Z]{2})(\d{3,4})|([a-zA-Z]{3})(\d{2,3}))$/

export const toInputUppercase = (e: FormEvent<HTMLInputElement>) => {
  e.currentTarget.value = ('' + e.currentTarget.value).toUpperCase()
}

export const isObjEmpty = (obj: Object) => Object.keys(obj).length === 0

export const fetchSumOfKey = (arr: any[], property: string): number => {
  if (!arr || arr.length === 0) return 0
  return arr.map((item: any) => item[property] || 0).reduce((prev: any, curr: any) => prev + curr, 0)
}

export const percentage = (partialValue: number, total: number) => (100 * partialValue) / total
